import { uniqueBy } from 'lib/array/arrayUtils'
import { useMemo } from 'react'

type TicketParams = {
  time?: string
  isBuyNowBookLater?: boolean
  isGift?: boolean
}

export function useExperienceTicketsOptions(availableTimes: Array<App.ExperienceAvailabilityTimeSlot> | undefined, params: TicketParams) {
  const { isBuyNowBookLater, isGift, time } = params

  return useMemo(() => {
    const allSlotsForTime = (availableTimes ?? []).filter(slot => isBuyNowBookLater || isGift || slot.time === time)
    const tickets = allSlotsForTime.flatMap(slot => slot.tickets)
    return uniqueBy(tickets, ticket => `${ticket.fareType}-${ticket.id}`)
  }, [availableTimes, isBuyNowBookLater, isGift, time])
}
